import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import { makeStyles } from 'styles/util';
import { getStorageSiteAndStorageTitle } from 'helpers/StorageSiteHelper';
import strings from 'localization/strings';
import routes from 'routes';
import { formatTimePeriod } from 'helpers/StringHelper';
import adminBookingStatuses from 'enums/adminBookingStatuses';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import StorageSiteImage from '../StorageSiteImage';
import IconPrefix from 'common/IconPrefix';
import CardLink from 'common/CardLink';
import PersonIcon from '@material-ui/icons/Person';
import ChevronRight from 'common/ChevronRight';
import StatusChip from 'common/StatusChip';


const useStyles = makeStyles(({ theme, colors }) => ({
    icon: {
        marginLeft: '-4px'
    },
    information: {
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        '& > :first-child': {
            flex: '1 1 auto'
        },
        '& > :last-child': {
            display: 'flex',
            flex: '0 0 auto'
        }
    },
    bookingContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'start',
        padding: theme.spacing(0, 1, 0, 1),
        gap: theme.spacing(1.875)
    },
    image: {
        display: 'flex',
        '& img': {
            height: '100%',
            width: '100%',
            objectFit: 'cover'
        }
    },
    chevronRight: {
        fill: colors.secondaryColor
    }
}));

const OwnerBookingListItem = ({ booking }) => {
    const classes = useStyles();
    const { appContext } = useAppContext();
    const storageGroup = booking.storageGroup;
    const storageSite = storageGroup.storageSite;
    const title = getStorageSiteAndStorageTitle(booking.storage, storageGroup);

    const imageUrl = storageSite.images[0]
        ? storageSite.images[0].mediaUrl
        : undefined;

    const manageUrl = routes.account.ownerBookingDetails.replace(':bookingId', booking.id);

    const getLabelForBooking = () => {
        const prefix = strings.bookingLabelPrefixes[booking.adminBookingStatus];
        const type = booking.subscriptionBooking
            ? strings.subscriptionBookingLowercase
            : strings.periodBookingLowercase;
        return <>{prefix} {type}</>;
    };

    const getPeriodForBooking = () => {
        return formatTimePeriod(booking);
    };

    return (
        <CardLink to={manageUrl}>
            <Box className={classes.image}>
                <StorageSiteImage storageSite={storageSite} imageUrl={imageUrl} width={385} height={182} />
            </Box>
            <Box className={classes.information}>
                <Typography variant="h5" component="p">
                    {title}
                </Typography>
                <ChevronRight className={classes.chevronRight} />
            </Box>
            <Box className={classes.bookingContent}>
                <IconPrefix className={classes.icon} icon={<PersonIcon htmlColor={appContext.colors.icon}/>}>
                    {booking.tenantActor.name}
                </IconPrefix>
                <StatusChip text={getPeriodForBooking()} heading={getLabelForBooking()} status={adminBookingStatuses[booking.adminBookingStatus].chipType}/>
            </Box>
        </CardLink>
    );
};

OwnerBookingListItem.propTypes = {
    booking: PropTypes.object.isRequired
};

export default OwnerBookingListItem;

